// removed by extract-text-webpack-plugin
module.exports = {"bread":"bread___3y-rA","home":"home___1TZso"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Bread.less
// module id = 705
// module chunks = 37